import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import Quota from '../list/quota';
import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

const API_PATH = 'quotas';

export const QuotaManager = {
  objects: {
    ...objectsRHandler(API_PATH, Quota),
    setDefault({ data, obs } = DEFAULT_PARAMS) { // { "participant_count": "45", "event_id": "1461", "organizer_id": 328 }
      return rHandler(
        apiService.post(`${API_PATH}/default`, data),
        (response) => (response),
        (error) => ({ error }),
        obs,
      );
    },
  },
};
